// extracted by mini-css-extract-plugin
export default {"PixelDropdown":"SwitchDisplayModeView_PixelDropdown__0PgB8"};